package org.hs_soft.runmynesto.data.api_datasource.product.tabs.tab_product_general

import com.varabyte.kobweb.browser.http.http
import kotlinx.browser.window
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.delay
import kotlinx.coroutines.withContext
import kotlinx.coroutines.withTimeout
import kotlinx.serialization.builtins.ListSerializer
import kotlinx.serialization.builtins.serializer
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.JsonPrimitive
import kotlinx.serialization.json.buildJsonObject
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.repository.network_datasource.product.tab_product_general.SaveDataAssistantFavoriteMessagesRepository
import org.hs_soft.runmynesto.domain.util.ApiPath
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.util.Constants
import org.hs_soft.runmynesto.domain.util.parseData
import kotlin.time.Duration.Companion.seconds

class SaveDataAssistantFavoriteMessagesRepositoryImpl(
    private val requestManager: RequestManager
) : SaveDataAssistantFavoriteMessagesRepository {

    private val abortController = requestManager.createController()

    override suspend fun saveDataAssistantFavoriteMessages(assistant: String, email: String, favoriteMessages:List<String>): String? {

        return withContext(Dispatchers.Default) {
            retry(times = 3, initialDelay = 2.seconds) {
                withTimeout(Constants.timeout.seconds) {
                    fetchAnswer(assistant, email, favoriteMessages)
                }
            }
        }
    }

    private suspend fun fetchAnswer(assistant: String, email: String, favoriteMessages:List<String>): String {
        val abortController = requestManager.createController()

        val headers = mapOf(
            "Content-Type" to "application/json",
            "x-api-key" to ApiUtils.API_KEY.RESTAURANTS_API_KEY_VALUE,
        )

        val jsonBody = Json.encodeToString(ListSerializer(String.serializer()), favoriteMessages)
        val bodyByteArray = jsonBody.encodeToByteArray()

        val result = window.http.post(
            resource = ApiUtils.Domain.dataAssistantDomain + ApiPath.saveDataAssistantFavoriteMessages +
                    "?${ApiUtils.Field.assistant}=$assistant" +
                    "&${ApiUtils.Field.email}=$email",
            headers = headers,
            abortController = abortController,
            body = bodyByteArray
        ).decodeToString()

        return result.parseData<String>()
    }


    private suspend fun <T> retry(
        times: Int,
        initialDelay: kotlin.time.Duration,
        factor: Double = 2.0,
        block: suspend () -> T
    ): T {
        var currentDelay = initialDelay
        repeat(times - 1) {
            try {
                return block()
            } catch (e: Exception) {
                // You can add logging here
            }
            delay(currentDelay)
            currentDelay *= factor
        }
        return block() // last attempt
    }
}

